import {useDraggable} from "@dnd-kit/core"
import {Box, Button, styled} from "@mui/material"
import React from "react"
import {CSS} from "@dnd-kit/utilities"

const DragableButton = styled(Button)(({theme}) => theme.DRAGABLE_BUTTON)

const DraggableItem = ({item, defaultPosition, triggerAction}) => {
    const handleClick = clickedItem => {
        triggerAction("ADD_LIFESTONE", clickedItem)
    }

    const {x = 0, y = 0} = item.position || defaultPosition
    const {attributes, listeners, setNodeRef, transform, isDragging} =
        useDraggable({id: item.id})
    const currentTransform = {
        x: x + (transform ? transform.x : 0),
        y: y + (transform ? transform.y : 0),
        scaleX: 1,
        scaleY: 1,
    }

    const style = {
        position: "absolute",
        transform: CSS.Translate.toString(currentTransform),
        opacity: isDragging ? 0.6 : 1,
        transition: isDragging ? "none" : "transform 0.2s ease-out",
        boxShadow: isDragging
            ? "0 8px 16px rgba(0,0,0,0.3)"
            : "0 1px 3px rgba(0,0,0,0.1)",
        zIndex: isDragging ? 1000 : 900,
        color: "#ffffff",
        backgroundColor: "#fff",
        width: "122px",
        height: "100px",
        borderRadius: "4px",
        padding: "5px",
        border: "solid 1px #f3f3f3",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-around",
        cursor: "grab",
    }

    return (
        <Box ref={setNodeRef} style={style}>
            <div
                {...listeners}
                {...attributes}
                style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <div
                    style={{
                        borderRadius: "50%",
                        border: "solid 1px #b2beef",
                        color: "#b2beef",
                        width: "40px",
                        height: "40px",
                        padding: "7px",
                    }}
                >
                    {item.icon ? (
                        <img src={item.icon} alt={item.label} />
                    ) : (
                        <></>
                    )}
                </div>
            </div>
            <DragableButton
                variant="contained"
                onClick={() => handleClick(item)}
                style={{width: "80%", fontSize: "14px"}}
            >
                {item?.label}
            </DragableButton>
        </Box>
    )
}

export default DraggableItem
